<ix-conf-table
  [conf]="tableConfig"
></ix-conf-table>
